module.exports = __webpack_public_path__ + "media/images/smile-2-87119936ab1a05688e7dbe2952a51a50.svg";